import { keys, map, pipe } from 'ramda';
import * as RA from 'ramda-adjunct';
import { viewData } from '../../../services/ramda';

export const createTaskModel = ({
  is_done = undefined,
  section = undefined,
  timestamped = undefined,
  group_name = undefined,
  name = undefined,
  created = undefined,
  user_id = undefined,
  user_name = undefined,
  assignto_user_id = undefined,
  external_id = undefined,
  checklist_id = undefined,
  external_table = undefined,
  editing = false
}) => {
  return {
    is_done,
    section,
    timestamped,
    group_name,
    name,
    created,
    user_id,
    user_name,
    assignto_user_id,
    external_id,
    checklist_id,
    external_table,
    editing
  }
};

export const createChecklistGroupItems = (obj = {}) => {
  return keys(obj).map(key => {
    return {
      name: key,
      checklist_items: map(createTaskModel, obj[key]),
      editing: false,
      id: key.replace(/\s/g, '')
    }
  })
};

export const createChecklistItems = pipe(
  viewData([], 'checklist_items'),
  map(createTaskModel)
);
